export const FALLBACK_URL =
    'https://fiverr-res.cloudinary.com/image/upload/v1554030084/search_perseus/fallback-image.png';
export const NOT_FOUND_STATUS = 404;
export const IMG_LOADING_TYPES = {
    LAZY: 'lazy',
    EAGER: 'eager',
};
